import {Anchor, Breadcrumbs} from '@mantine/core';
import type React from 'react';
import {MdArrowRight} from 'react-icons/md';
import {useMediaQuery} from '../services/useMediaQuery';

type Props = {
  crumbs: Array<{label: string; href: string}>;
};

export const BreadcrumbsComponent: React.FC<Props> = ({crumbs}) => {
  const {isPC} = useMediaQuery();

  return (
    <>
      <Breadcrumbs
        separator={<MdArrowRight size={25} />}
        sx={
          isPC
            ? {}
            : {
                '& .mantine-Breadcrumbs-separator': {
                  margin: '0 4px',
                },
              }
        }
      >
        {crumbs.map((crumb, index) => (
          <div
            key={index}
            className={`${index === crumbs.length - 1 && 'overflow-hidden text-ellipsis whitespace-nowrap pb-[2px]'}`}
          >
            {index === crumbs.length - 1 ? (
              <span className="text-black-2 text-[10px] pc:text-base">
                {crumb.label}
              </span>
            ) : (
              <Anchor
                href={crumb.href}
                className="text-primary-1 hover:underline hover:opacity-50 text-[10px] pc:text-base font-bold"
              >
                {crumb.label}
              </Anchor>
            )}
          </div>
        ))}
      </Breadcrumbs>
    </>
  );
};
